import {
  MeterOnboardingStateProps,
  meterOnboardingState,
} from '../../atoms/meterOnboardingWizardAtom';
import React, { Fragment } from 'react';
import { UIStateProps, uiState } from '../../atoms/uiAtom';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import Button from '../common/Button';
import { DuRoleEnum } from '../../enum/DuRoleEnum';
import { EanEligibilityStatusEnum } from '../../enum/EanEligibilityStatusEnum';
import { EanUtils } from '../../common/eanUtils';
import Loader from '../common/Loader';
import { SDPTariffChoiceEnum } from '../../enum/SDPTariffChoiceEnum';
import { STEP_ADD_EAN_ID } from './StepAddMeter';
import { STEP_ASK_CONSENT_METER_CONFIRM_ID } from './StepAskConsentMeterConfirm';
import StepConfirmMeter from './StepConfirmMeter';
import { usePostValidateEan } from '../../hooks/meters';
import { useTranslation } from 'react-i18next';
import { useWizard } from 'react-use-wizard';

export const STEP_ASK_CONTENT_METER_ID = 'step-ask-consent-meter';
export default function StepAskConsentMeter() {
  const { t } = useTranslation();
  const meterOnboarding = useRecoilValue<MeterOnboardingStateProps>(meterOnboardingState);
  const setUiState = useSetRecoilState<UIStateProps>(uiState);
  const { goToStep } = useWizard();

  const { isPending: isPendingPostValidateEan, mutateAsync: postValidateEan } =
    usePostValidateEan();

  const handleClickConfirmAskConsent = () => {
    postValidateEan({
      ean: meterOnboarding.ean,
      rate: SDPTariffChoiceEnum.NONE,
      role: DuRoleEnum.DELEGATE,
      eligibility: meterOnboarding.eanEligibilityOutResponse,
    })
      .then((responseValidateEan) => {
        if (responseValidateEan.status === 500) {
          setUiState((prev) => ({
            ...prev,
            hasError: true,
          }));
        } else if (responseValidateEan.status === 409) {
          setUiState((prev) => ({
            ...prev,
            hasError: t(EanUtils.getEanEligibilityStatusError(EanEligibilityStatusEnum.Conflict)),
          }));
        } else if (responseValidateEan.status === 201) {
          const eanEligibilityStatus = EanUtils.getEanEligibilityStatus(
            responseValidateEan.data!.code
          );
          if (eanEligibilityStatus === EanEligibilityStatusEnum.AskConsent) {
            goToStep(
              meterOnboarding.steps?.findIndex((s) => s.id === STEP_ASK_CONSENT_METER_CONFIRM_ID)!
            );
          } else {
            setUiState((prev) => ({
              ...prev,
              hasError: t(EanUtils.getEanEligibilityStatusError(eanEligibilityStatus)),
            }));
          }
        }
      })
      .catch(() => {
        setUiState((prev) => ({ ...prev, hasError: true }));
      });
  };

  const handleClickCancel = () => {
    goToStep(meterOnboarding.steps?.findIndex((s) => s.id === STEP_ADD_EAN_ID)!);
  };

  return (
    <StepConfirmMeter
      dataTestId={STEP_ASK_CONTENT_METER_ID}
      message={t('step.ask.consent.meter.message')}
      description={t('step.ask.consent.meter.description')}
      actionLabel={t('step.ask.consent.meter.btn.label')}
      actions={
        <Fragment>
          <Button className="btn btn--secondary" onClick={handleClickCancel}>
            {t('common.cancel')}
          </Button>
          <Button
            isDisabled={isPendingPostValidateEan}
            prefix={isPendingPostValidateEan ? <Loader /> : null}
            type="submit"
            className="btn btn--primary"
            onClick={handleClickConfirmAskConsent}
          >
            {t('step.ask.consent.meter.btn.label')}
          </Button>
        </Fragment>
      }
    >
      <h4 className="wizard__caption">
        {t('step.ask.consent.meter.caption', {
          ownerEmail: meterOnboarding.eanEligibilityOutResponse.ownerEmail,
        })}
      </h4>
    </StepConfirmMeter>
  );
}
